exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-header[data-v-89f2b8ec]{display:flex;align-items:center;justify-content:space-between;gap:1rem;margin-bottom:2rem}.filter-section[data-v-89f2b8ec]{margin-bottom:1.5rem}.search-column[data-v-89f2b8ec]{max-width:360px}.ag-grid-container[data-v-89f2b8ec]{padding:0}.row-count-footer[data-v-89f2b8ec]{padding:.65rem 1rem;border-top:1px solid #f0f0f0;font-size:.813rem;color:#7a7a7a;text-align:right}.state-block[data-v-89f2b8ec]{padding:4rem 1rem;text-align:center}.state-title[data-v-89f2b8ec]{margin-bottom:1rem;color:#7a7a7a;font-size:1.1rem}.block-error-strip[data-v-89f2b8ec]{display:flex;align-items:center;justify-content:center;gap:1rem;padding:.6rem 1rem;border-top:1px solid #f0f0f0;background-color:#fff5f5;color:#cc0f35;font-size:.875rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-89f2b8ec","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=2!./src/components/users/views/Users.vue
// module id = 1998
// module chunks = 2